import { render, staticRenderFns } from "./mockDialog.vue?vue&type=template&id=1bd3c0d8&scoped=true"
import script from "./mockDialog.vue?vue&type=script&lang=js"
export * from "./mockDialog.vue?vue&type=script&lang=js"
import style0 from "./mockDialog.vue?vue&type=style&index=0&id=1bd3c0d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3c0d8",
  null
  
)

export default component.exports